import type { ReactNode } from 'react';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import type { Crumb } from './Breadcrumbs';

export function AppLayout({ crumbs, children }: { crumbs: Crumb[]; children: ReactNode }) {
  return (
    <div className="min-h-screen grid grid-cols-1 md:grid-cols-[212px_1fr] bg-bg text-fg">
      <Sidebar />
      <div className="flex min-w-0 flex-col">
        <Topbar crumbs={crumbs} />
        <main className="flex-1 min-w-0">{children}</main>
      </div>
    </div>
  );
}
